import { Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';

export const Title = () => {
  const dictionary = Dictionary[DICTIONARY.Equipment];

  return (
    <>
      <Typography component='h1' variant='h2'>
        {dictionary.title}
      </Typography>
    </>
  );
};
